import React, { Component } from "react"
import { injectStripe } from "react-stripe-elements"
import Modal from "react-bootstrap/lib/Modal"
import BillingInfoForm from "./billing_info_form"
import BillingInfoSidebar from "./billing_info_sidebar"
import { Spinner } from "@blueprintjs/core"

class BillingInfo extends Component {
    constructor(props) {
        super(props)
    }

    submitNewPayment = () => {
        // stripe props are coming in through <StripeProvider>
        const {
            name,
            handleStripeToken,
            stripe,
            paymentPlan: { planName },
            teamId,
            history,
        } = this.props
        const stripeTokenMeta = { name, planName, stripe, teamId, history }

        handleStripeToken({ stripeTokenMeta })
    }

    submitUpdatePayment = () => {
        // stripe props are coming in through <StripeProvider>
        const { name, handleChangePaymentMethod, stripe } = this.props

        handleChangePaymentMethod(name, stripe)
    }

    generatePaymentFunction = customer =>
        customer.trialEnd
            ? this.submitNewPayment
            : !!customer && customer.stripePlan
                ? this.submitUpdatePayment
                : this.submitNewPayment

    generateUpdateOrUpgradeText = (customer, isUpgrade) =>
        isUpgrade
            ? "Upgrade"
            : !!customer && customer.stripePlan
                ? "Update"
                : "Upgrade"

    renderButton = (customer, isLoading, isUpgrade) => (
        <button
            className="btn btn-primary upgrade-button"
            onClick={this.generatePaymentFunction(customer)}
            disabled={isLoading}
        >
            {isLoading ? (
                <Spinner />
            ) : (
                this.generateUpdateOrUpgradeText(customer, isUpgrade)
            )}
        </button>
    )

    render() {
        const {
            togglePaymentModal,
            name,
            handleSetName,
            paymentPlan,
            isNameValid,
            customer,
            teamMembers,
            isLoading,
            isUpgrade,
        } = this.props
        return (
            <div>
                <Modal.Body className="modal-body-billing-info">
                    <BillingInfoForm
                        name={name}
                        handleSetName={handleSetName}
                        isNameValid={isNameValid}
                    />
                    <BillingInfoSidebar
                        paymentPlan={paymentPlan}
                        customer={customer}
                        teamMembers={teamMembers}
                        isUpgrade={isUpgrade}
                    />
                </Modal.Body>
                <Modal.Footer className="payment-modal-footer">
                    <button
                        className="btn btn-light cancel-button"
                        onClick={togglePaymentModal}
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                    {this.renderButton(customer, isLoading, isUpgrade)}
                </Modal.Footer>
            </div>
        )
    }
}

export default injectStripe(BillingInfo)



// WEBPACK FOOTER //
// ./src/components/billing_info.jsx